module.exports = __webpack_public_path__ + "img/stats.8f932934.svg";